
export default {
  // head() {
  //   return {
  //     script: [
  //       { src: 'https://services.gastronovi.com/restaurants/82818/scripts/reservation', async: true }
  //     ]
  //     // Other head elements like meta tags can also be included here
  //   }
  // },
  props: {
    data: {
      type: Object,
      default: () => { }
    }
  }
};
